class RecordingGuest {
  id: number;

  vault_id: number;

  vault_title: string;

  email: string;

  name: string;

  expiration_date: string;

  token: string;

  vault_url: string;

  constructor(params: RecordingGuestType) {
    this.id = params.id;
    this.name = params.name;
    this.email = params.email;
    this.vault_id = params.vault_id;
    this.vault_title = params.vault_title;
    this.expiration_date = params.expiration_date;
    this.token = params.token;
    this.vault_url = params.vault_url;
  }
}

export { RecordingGuest };
